// Maison Sable. — Sauvegarde et pré-remplissage des mesures ongles
(function () {
  const FIELDS = [
    'Pouce Gauche', 'Pouce Droit',
    'Index Gauche', 'Index Droit',
    'Majeur Gauche', 'Majeur Droit',
    'Annulaire Gauche', 'Annulaire Droit',
    'Auriculaire Gauche', 'Auriculaire Droit'
  ];

  const METAFIELD_KEYS = [
    'pouce_gauche', 'pouce_droit',
    'index_gauche', 'index_droit',
    'majeur_gauche', 'majeur_droit',
    'annulaire_gauche', 'annulaire_droit',
    'auriculaire_gauche', 'auriculaire_droit'
  ];

  // Récupère les mesures sauvegardées depuis les métachamps client
  async function fetchSavedMeasurements() {
    try {
      const res = await fetch('/account?view=measurements-json', { credentials: 'include' });
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  // Pré-remplit les champs Easify avec les mesures sauvegardées
  async function prefillEasifyFields() {
    const saved = await fetchSavedMeasurements();
    if (!saved) return;

    FIELDS.forEach((label, i) => {
      const key = METAFIELD_KEYS[i];
      const value = saved[key];
      if (!value) return;

      // Easify génère des inputs avec le label comme identifiant
      const inputs = document.querySelectorAll(
        `input[placeholder*="${label}"], input[aria-label*="${label}"], .easify-option__label`
      );

      // Recherche par texte du label parent
      document.querySelectorAll('.easify-option').forEach(option => {
        const labelEl = option.querySelector('label, .easify-option__label');
        if (labelEl && labelEl.textContent.trim().includes(label)) {
          const input = option.querySelector('input[type="text"], input[type="number"]');
          if (input && !input.value) {
            input.value = value;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    });
  }

  // Sauvegarde les mesures via l'API Customer Account (endpoint custom)
  async function saveMeasurements(data) {
    return fetch('/apps/measurements/save', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(data)
    });
  }

  // Écoute la soumission du formulaire Easify pour sauvegarder les mesures
  function watchEasifyForm() {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;

      const measurements = {};
      FIELDS.forEach((label, i) => {
        const key = METAFIELD_KEYS[i];
        form.querySelectorAll('.easify-option').forEach(option => {
          const labelEl = option.querySelector('label, .easify-option__label');
          if (labelEl && labelEl.textContent.trim().includes(label)) {
            const input = option.querySelector('input[type="text"], input[type="number"]');
            if (input && input.value) {
              measurements[key] = input.value;
            }
          }
        });
      });

      if (Object.keys(measurements).length > 0) {
        await saveMeasurements(measurements);
      }
    }, true);
  }

  // Init
  document.addEventListener('DOMContentLoaded', () => {
    prefillEasifyFields();
    watchEasifyForm();

    // Retry si Easify charge en asynchrone
    setTimeout(prefillEasifyFields, 1500);
    setTimeout(prefillEasifyFields, 3000);
  });
})();